import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

function CountDownTimer({
  startDate, endDate, onEnd,
}) {
  const [timeLeft, setTimeLeft] = useState({});
  // const targetDate = new Date('2025-06-27T08:51:47.400Z');

  useEffect(() => {
    const interval = setInterval(() => {
      const now = new Date();
      const eventStartLocal = new Date(startDate);
      const eventEndLocal = new Date(endDate);
      const timeToStart = eventStartLocal.getTime() - now.getTime();
      const timeToEnd = eventEndLocal.getTime() - now.getTime();

      if (timeToEnd <= 0) {
        clearInterval(interval);
        onEnd('ended');
        return;
      }

      if (timeToStart <= 0) {
        onEnd('started');
        return;
      }

      if (timeToStart <= 24 * 60 * 60 * 1000) {
        const totalSeconds = Math.floor(timeToStart / 1000);
        const hours = Math.floor(totalSeconds / 3600);
        const minutes = Math.floor((totalSeconds % 3600) / 60);
        const seconds = totalSeconds % 60;
        setTimeLeft({ hours, minutes, seconds });
      } else {
        setTimeLeft({ hours: 0, minutes: 0, seconds: 0 });
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [startDate, endDate, onEnd]);

  return (
    <div className="w-full px-4 py-5 rounded-[6px] border border-b-4 border-[#1ea0ff] flex items-center justify-evenly">

      <div className="text-center">
        {/* <span className="block text-3xl text-[#025795] font-[600]">{format(time.hour)}</span> */}
        <span className="block text-3xl text-[#025795] font-[600]">{timeLeft.hours}</span>
        <span className="block font-[400] text-[#025795]">Hour</span>
      </div>
      <span>:</span>
      <div className="text-center">
        {/* <span className="block text-3xl text-[#025795] font-[600]">{format(time.minute)}</span> */}
        <span className="block text-3xl text-[#025795] font-[600]">{timeLeft.minutes}</span>
        <span className="block font-[400] text-[#025795]">Minutes</span>
      </div>
      <span>:</span>
      <div className="text-center">
        {/* <span className="block text-3xl text-[#025795] font-[600]">{format(time.second)}</span> */}
        <span className="block text-3xl text-[#025795] font-[600]">{timeLeft.seconds}</span>
        <span className="block font-[400] text-[#025795]">Seconds</span>
      </div>
    </div>
  );
}

CountDownTimer.propTypes = {
  startDate: PropTypes.number.isRequired,
  endDate: PropTypes.number.isRequired,
  onEnd: PropTypes.func.isRequired,
};

export default CountDownTimer;
